import React from "react";
import Timer from "./Timer";
import AlertMessage from "./AlertMessage";
import TravelerForm from "../TravelerForm";
import { handleNavigation } from "../../../Utils/utils-functions";

const BookingForm = ({ onNext }) => {
  // const formik = useFormik({
  //   initialValues: {
  //     mobileNumber: "",
  //     email: "",
  //     firstName: "",
  //     lastName: "",
  //     dateOfBirth: "",
  //   },
  //   validationSchema: Yup.object({
  //     mobileNumber: Yup.string()
  //       .required("Mobile number is required")
  //       .matches(/^[0-9]{11}$/, "Invalid mobile number format"),
  //     email: Yup.string()
  //       .email("Invalid email address")
  //       .required("Email is required"),
  //     firstName: Yup.string().required("First name is required"),
  //     lastName: Yup.string().required("Last name is required"),
  //     dateOfBirth: Yup.date().required("Date of Birth is required"),
  //   }),
  //   onSubmit: () => {
  //     onNext();
  //   },
  // });

  return (
    <div className="">

      <div className="text-right text-black mb-4">
        <Timer />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <div>
            <AlertMessage />
          </div>
          <h2 className="text-lg font-reem mb-2">Contact Details</h2>
          <div className="bg-white p-4 rounded-lg mb-4">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm  mb-1">
                  Mobile Number
                </label>
                <div className="flex items-center border rounded-lg p-2 bg-white">
                  <span className="mr-2">🇵🇰 +92</span>
                  <input
                    type="text"
                    className="flex-1 outline-none"
                    value="3155121229"
                  />
                  <i className="fas fa-check-circle text-green-500 ml-2"></i>
                </div>
                <p className="text-sm text-gray-500 mt-1">e.g 03320234557</p>
              </div>
              <div>
                <label className="block text-sm  mb-1">
                  Email{" "}
                  <span className="text-gray-500">
                    (your ticket will be emailed here)
                  </span>
                </label>
                <div className="flex items-center border rounded-lg p-2 bg-white">
                  <input
                    type="email"
                    className="flex-1 outline-none"
                    placeholder="e.g. name@outlook.com"
                  />
                  <i className="fas fa-check-circle text-green-500 ml-2"></i>
                </div>
              </div>
            </div>
          </div>
          <h2 className="text-lg font-reem mb-2">
            Traveler Details for Adult 1
          </h2>
          <div className="bg-white p-4 rounded-lg">
            <TravelerForm />
          </div>
          <div className="my-6 flex justify-end">
          <button className="w-full bg-blue-600 text-white py-2 rounded-lg" onClick={() => handleNavigation('/payment')}>
            Continue
          </button>
          </div>


        </div>
        <div>
          <div className="boder border-b-2 p-4  mb-4">
            <h2 className=" mb-2">Your Bookings</h2>
            <div className="bg-white  border border-solid border-[#d9d9d9]">
              <div className="flex items-center justify-between text-xs font-reem text-gray-800 bg-[#f5f5f5] px-2 py-2 rounded-t border-b border-gray-300">
                <span>Departing</span>
                <span>09 Oct, 2024</span>
              </div>

              <div className="flex items-center space-x-2 text-gray-800 pl-3 pt-2 mb-2">
                <img
                  src="https://placehold.co/24x24"
                  alt="Airline logo"
                  className="w-6 h-6"
                />
                <span>Serene Air</span>
                <span>ER-503 (OW)</span>
              </div>
              <div className="flex  space-x-4 px-3 text-gray-800 font-reem">
                <span className="text-xl">06:35 PM</span>
                <span className="bg-[#f5f5f5] text-gray-600 px-2">2h</span>
                <span className="text-xl">08:35 PM</span>
              </div>
              <div className="text-gray-800 px-3 text-sm flex mb-2">
                <span>Islamabad (ISB) - </span>
                <span className="text-blue-600"> Nonstop </span>
                <span> - Karachi (KHI)</span>
              </div>
              <div className="text-gray-500 text-sm pl-3 pb-2 font-mulish">
                <span>Total: 40kg Pcs: 2</span>
              </div>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg mb-4">
            <div className="mr-4 flex items-center">
              <img src="data:image/svg+xml;base64,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" alt="Badge" className="w-10 h-10" />
              <h2 className=" font-mulish p-2 mb-2">
                Pakistan's most reliable booking platform!
              </h2>
            </div>


            <div className="flex items-center ">
              <div className="bg-[#e7eef5] p-2">
                <span className="text-yellow-500">
                  <i className="fas fa-star"></i>
                </span>
                <span className="text-yellow-500">
                  <i className="fas fa-star"></i>
                </span>
                <span className="text-yellow-500">
                  <i className="fas fa-star"></i>
                </span>
                <span className="text-yellow-500">
                  <i className="fas fa-star"></i>
                </span>
                <span className="text-yellow-500">
                  <i className="fas fa-star-half-alt"></i>
                </span>
              </div>
              <span className="text-white  p-2 font-reem bg-[#0a549c] rounded-e-md ">4.5</span>
              <span className="text-[#0a549c] font-mulish p-2 ">on</span>

              <img
                src="https://placehold.co/50x20"
                alt="Reviews logo"
                className="w-12 h-5"
              />
            </div>
          </div>
          <div className="bg-white  border border-solid border-[#d9d9d9]">
            <h2 className="text-xl font-reem text-[#08437d] bg-[#f5f5f5] px-5 py-2 rounded-t border-b border-gray-300">
              Price Summary
            </h2>
            <div className="flex items-center justify-between p-4 font-mulish text-sm  mb-2">
              <span>Serene Air (Adult x 1)</span>
              <span>PKR 17,875</span>
            </div>
            <div className="flex items-center justify-between  text-lg p-5 border font-reem border-t-2  ">
              <span>Price you pay</span>
              <span className="text-[#08437d] font-bold">PKR 17,875</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingForm;
